"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchPreviewQuery = void 0;
var _fetching = require("@ori/fetching");
var _fragments = require("./fragments");
var _links = require("./fragments/links");
/* istanbul ignore file  -- query */

const searchPreviewQuery = exports.searchPreviewQuery = (0, _fetching.gql)`
  query SearchPreview($query: String!, $limit: Int = 12) {
    application {
      productSearchPreview {
        searchResults(query: $query, top: $limit) {
          totalProductsCount
          suggestions
          products {
            ...SearchPreviewProduct
          }
          relatedCategoryLinks {
            ...SearchPreviewLink
          }
          relatedBrandLinks {
            ...SearchPreviewLink
          }
        }
      }
    }
  }
  ${_fragments.searchPreviewProduct}
  ${_links.links}
`;